import { DetailsBooking } from 'types';
import KnowBeforeYouGo from './components/KnowBeforeYouGo';
import * as track from 'lib/gaTracking/bookingDetailsPageEvents';
import { FC } from 'react';

interface KnowBeforeYouGoWithTrackingProps {
  booking: DetailsBooking;
}

const KnowBeforeYouGoWithTracking: FC<KnowBeforeYouGoWithTrackingProps> = ({ booking }) => (
  <KnowBeforeYouGo booking={booking} onToggle={track.checkInInstructionsDropdown} />
);

export default KnowBeforeYouGoWithTracking;
